module.exports = new __parcel__URL__("daisybell1.a292c481.jpg").toString();